/**
 * Path under this app's own origin that reverse-proxies the Kratos public API (rewrite in
 * next.config.ts). Same origin keeps Kratos off a public domain of its own, makes the session
 * cookie first-party and removes the need for CORS. Must match kratos.yml `serve.public.base_url`.
 * Dependency-free so next.config.ts can import it.
 */
export const KRATOS_PATH = '/.ory'
